import React from "react";
import { MainLayout } from "../../MainLayout";
import { UAESec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";
export const UAE = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/delhi-air.png",
            sliderimg: [
                {
                    id: 1,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/dest-itenary1.webp",
                    title: "Burj Khalifa",
                },
                {
                    id: 2,
                    img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/dest-itenary2.webp",
                    title: "The Dubai Mall",
                },
            ],
            title: "7N/8D Treasure of Dubai",
            days: "7N/8D",
            tags: ["Sightseeing", "Meals", "Cruise"],
            description: `The "Treasure of Dubai" is an 8-day, 7-night immersive tour offering a blend of modern marvels, cultural experiences, and thrilling adventures. Highlights include a Marina Dhow Cruise with dinner, a Dubai city tour, and an exhilarating Desert Safari with BBQ. Guests will explore Abu Dhabi’s Sheikh Zayed Grand Mosque and visit attractions like the Dubai Dolphinarium, Bird Show, Museum of the Future, and Sky View Observatory. Optional experiences such as Burj Khalifa, Ferrari World, Miracle Garden, and Global Village add to the excitement, culminating in a seamless airport transfer with unforgettable memories.`,
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/dest-itenary1.webp",
            slug: "treasureOfDubai",
        },

        {
            title: "6N/7D Panoramic Dubai",
            days: "6N/7D",
            tags: ["Safari", "Meals", "Sightseeing"],
            description:
                "Experience the magic of Dubai with this 7-day, 6-night panoramic tour filled with iconic attractions and cultural experiences. Begin with a scenic Marina Dhow Cruise dinner, followed by a half-day city tour and an adventurous Desert Safari with BBQ dinner and entertainment. Explore Abu Dhabi’s highlights, including the Sheikh Zayed Grand Mosque, then visit the Dubai Dolphinarium, Bird Show, and Dubai Frame. Enjoy a day of leisure or explore the enchanting Miracle Garden and vibrant Global Village before bidding farewell to this dazzling city.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/desert.webp",
            slug: "panoramicDubai",
        },

        {
            title: "5N/6D Dubai - Kids Fun Special",
            days: "5N/6D",
            tags: ["Meals", "Mosque", "Sightseeing"],
            description:
                "Experience an unforgettable 6-day Dubai and Abu Dhabi adventure, featuring luxurious stays, thrilling activities, and cultural explorations. Begin with a Marina Dhow Cruise and a guided city tour showcasing Dubai’s iconic landmarks, followed by an exhilarating Desert Safari. Explore Abu Dhabi with visits to the Sheikh Zayed Grand Mosque and the exciting Ferrari World or Warner Bros. World theme parks. Conclude your journey with cherished memories and a private airport drop-off.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/dubai1.webp",
            slug: "dubaiKidsFunSpecial",
        },

        {
            title: "4N/5D Dazzling Dubai",
            days: "4N/5D",
            tags: ["Meals", "Mosque", "Cruise"],
            description:
                "Experience the best of Dubai with this 5-day, 4-night adventure filled with luxury and excitement. Begin with a scenic Marina Dhow Cruise dinner, followed by a half-day city tour exploring Dubai’s modern and cultural landmarks. Enjoy an exhilarating desert safari with dune bashing, a BBQ dinner, and live entertainment, then take a full-day tour of Abu Dhabi, including the stunning Sheikh Zayed Grand Mosque. Conclude your trip with unforgettable memories before departing from Dubai.",
            img: "https://blueberrydatastorage.blob.core.windows.net/dmc/Assests/dubaigateway.webp",
            slug: "dazzlingDubai",
        },
    ];

    const topcitydata = [
        {
            id: 1, title: "Dubai", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Dubai%20Top%20Places/Dubai%20Top%20Places/Dubai.webp", desc: [
                <p><strong>Why Visit: </strong>Dubai is the UAE's most famous city, known for its futuristic skyline, luxury shopping, world-class entertainment, and high-end lifestyle. It's a city of superlatives, home to the Burj Khalifa (the world’s tallest building) and a thriving cultural and business hub.</p>,
                <p><strong>Top Attractions: </strong>Burj Khalifa, Dubai Mall, Dubai Fountain, Palm Jumeirah, Burj Al Arab, Dubai Marina, Dubai Museum, Dubai Aquarium & Underwater Zoo, and Desert Safaris.</p>
            ]
        },
        {
            id: 2, title: "Abu Dhabi", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Dubai%20Top%20Places/Dubai%20Top%20Places/Abu%20dhabi.webp", desc: [
                <p><strong>Why Visit: </strong>The capital of the UAE, Abu Dhabi is known for its cultural richness, modern architecture, and beautiful beaches. It is a mix of traditional Arab culture and contemporary development. It’s less flashy than Dubai but offers stunning cultural landmarks and luxurious experiences.</p>,
                <p><strong>Top Attractions: </strong>Sheikh Zayed Grand Mosque, Louvre Abu Dhabi, Yas Island (home to Ferrari World and Yas Waterworld), Qasr Al Watan, Emirates Palace, and Corniche Beach.</p>
            ]
        },
        {
            id: 4, title: "Sharjah", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Sarjah%20UAE.webp", desc: [
                <p><strong>Why Visit: </strong>Known as the cultural capital of the UAE, Sharjah offers a more traditional Arabian experience with its museums, galleries, and markets. It has a more relaxed atmosphere compared to Dubai and Abu Dhabi and is ideal for those seeking to experience the UAE's rich heritage.</p>,
                <p><strong>Top Attractions: </strong>Sharjah Art Museum, Sharjah Aquarium, Al Noor Island, Al Majaz Waterfront, Sharjah Heritage Area, and Blue Souk (Central Market).</p>
            ]
        },
        {
            id: 5, title: "Ajman", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Ajman%20UAE.webp", desc: [
                <p><strong>Why Visit: </strong>The smallest emirate in the UAE, Ajman is a peaceful destination known for its quiet beaches and laid-back lifestyle. It's perfect for Visitors seeking a more relaxed and low-key environment, with beautiful beaches and a charming old town.</p>,
                <p><strong>Top Attractions: </strong>Ajman Beach, Ajman Museum, Al Zorah Nature Reserve, and Al Nimra Mosque.</p>
            ]
        },
        {
            id: 6, title: "Fujairah", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Fujairah%20UAE.webp", desc: [
                <p><strong>Why Visit: </strong>Located on the eastern coast of the UAE along the Gulf of Oman, Fujairah is known for its stunning beaches, mountains, and rich history. It is a great destination for nature lovers and adventure seekers, with plenty of hiking, diving, and cultural attractions.</p>,
                <p><strong>Top Attractions: </strong>Fujairah Fort, Al Bidyah Mosque, Fujairah Museum, Snoopy Island (for diving), and the Hajar Mountains.</p>
            ]
        },
        {
            id: 7, title: "Ras Al Khaimah", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Ras%20Al%20Khaimah.webp", desc: [
                <p><strong>Why Visit: </strong>Known for its natural beauty, Ras Al Khaimah (RAK) is a more tranquil and scenic destination compared to Dubai and Abu Dhabi. It offers a mix of beach resorts, hiking in the mountains, and a variety of outdoor activities.</p>,
                <p><strong>Top Attractions: </strong>Jebel Jais (UAE's highest peak), Ras Al Khaimah National Museum, Al Marjan Island, Dhayah Fort, and Wadi Shawka (hiking and nature).</p>
            ]
        },
        {
            id: 8, title: "Umm Al Quwain", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Umm%20Al%20Quwain.webp", desc: [
                <p><strong>Why Visit: </strong>One of the quieter emirates, Umm Al Quwain offers a peaceful escape with fewer crowds and a more relaxed atmosphere. It's known for its beautiful beaches, desert dunes, and family-friendly attractions.</p>,
                <p><strong>Top Attractions: </strong>Umm Al Quwain Museum, Dreamland Aqua Park, and Al Sinniyah Island (a wildlife sanctuary).</p>
            ]
        },
        {
            id: 9, title: "Al Ain", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Al%20Ain%20UAE.webp", desc: [
                <p><strong>Why Visit: </strong>Known as the "Garden City," Al Ain is located in the eastern part of Abu Dhabi and offers a more traditional and rural experience. It's famous for its parks, natural springs, and historical sites, making it a great destination for family vacations and cultural exploration.</p>,
                <p><strong>Top Attractions: </strong>Al Ain Zoo, Jebel Hafeet, Al Ain Oasis, Al Jahili Fort, Sheikh Zayed Palace Museum, and Hot Springs.</p>
            ]
        },
        {
            id: 10, title: "Khor Fakkan", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Khor%20Fakkan.webp", desc: [
                <p><strong>Why Visit: </strong>Khor Fakkan is a small town located on the Gulf of Oman and is known for its beautiful beaches, dramatic mountain landscapes, and historical forts. It's a peaceful destination perfect for relaxing and enjoying nature.</p>,
                <p><strong>Top Attractions: </strong>Khor Fakkan Beach, Al Rabi Tower, Khor Fakkan Port, and Wadi Wurayah.</p>
            ]
        }

    ]

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Custom UAE Itineraries",
            desc: "Combine dynamic city experiences in Dubai with cultural depth in Abu Dhabi into well-planned, high-value travel programs suited for varied client segments."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Guided City & Cultural Tours",
            desc: "Offer structured explorations covering modern landmarks, heritage districts, and curated experiences, delivered with professional guides and flexible formats."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Luxury Hotels & Resort Portfolio",
            desc: "Access a wide network of city hotels, beachfront resorts, and premium properties with strong availability and competitive contracting options."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Desert Experiences & Premium Camps",
            desc: "Integrate desert safaris with standard, private, and luxury camp setups, ensuring consistent quality and smooth execution across bookings."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Attraction & Experience Integration",
            desc: "Include key attractions like Burj Khalifa, theme parks, and cultural venues with pre-arranged access and streamlined planning."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Retail & Lifestyle Experiences",
            desc: "Incorporate shopping districts, luxury malls, and local souks as flexible additions within itineraries, aligned with traveler preferences."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "MICE & Group Travel Solutions",
            desc: "Deliver efficient planning for meetings, incentives, and group travel with venue coordination and scalable logistics support."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "End-to-End Ground Handling",
            desc: "Local teams ensure smooth execution with real-time coordination and quick issue handling, suitable for both small bookings and high-volume travel programs."
        },
    ];
    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Dubai2.webp")'}
                text2={"UAE"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={UAESec1Data} />
             <IndiaSec2 countryCode="AE" />
            <IndiaSec3 data={topcitydata} name={"UAE"} />
            <IndiaSec4
                data={data}
                heading={"Designed Experiences Across the UAE "}
            />
            <Footer />

        </>
    )


};